import { useTenant } from "modules/tenant/providers/tenant-provider";
import { ReactNode } from "react";

const RoleWrapper = ({
  permissions,
  children,
}: {
  permissions: "read_bank_accounts" | "write_bank_accounts";
  children: ReactNode;
}) => {
  const { user } = useTenant();
  return user.role[permissions] ? <>{children}</> : null;
};

export default RoleWrapper;
